/*    
<summary>
   This file is used to provide initial values or state to the Fota Module observables.
   Developer: Aashish Singh, Created Date: 28-August-2024
</summary>
*/

import { ISchedulerHistoryListVm } from "../../models/response/IReleaseSchedulerHistoryResponse";

export const initialReleaseSchedulerHistoryState: ISchedulerHistoryListVm= {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    History: []
}